import { render, staticRenderFns } from "./SenhaEsqueceu.vue?vue&type=template&id=dccf01fa&scoped=true"
import script from "./SenhaEsqueceu.vue?vue&type=script&lang=js"
export * from "./SenhaEsqueceu.vue?vue&type=script&lang=js"
import style0 from "./SenhaEsqueceu.vue?vue&type=style&index=0&id=dccf01fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dccf01fa",
  null
  
)

export default component.exports